export const OPEN_MODAL  = 'OPEN_MODAL';
export const CLOSE_MODAL= 'CLOSE_MODAL';
export const OPEN_DATA_MODAL  = 'OPEN_DATA_MODAL';
export const CLOSE_DATA_MODAL= 'CLOSE_DATA_MODAL';
export const OPEN_WELCOME = 'OPEN_WELCOME';
export const CLOSE_WELCOME = 'CLOSE_WELCOME';

export const openModal = (zone, des, image, credits, imageDes) => ({
  type: OPEN_MODAL,
  open: true,
  zone,
  des,
  image, 
  credits,
  imageDes
}); 

export const closeModal = (zone, des, image, credits, imageDes) => ({
  type: CLOSE_MODAL,
  open: false,
  zone,
  des,
  image,
  credits,
  imageDes
});

export const openDataModal = () => ({
  type: OPEN_DATA_MODAL,
  openData: true
});

export const closeDataModal = () => ({
  type: CLOSE_DATA_MODAL,
  openData: false
});

export const openWelcomeModal = (zone, des, image, credits, imageDes) => ({
  type: OPEN_WELCOME,
  zone,
  des,
  image, 
  credits,
  imageDes
});

export const closeWelcomeModal = () => ({
  type: CLOSE_WELCOME
});
